import UmsUserManagementActionTypes from './types';

export const setAnyData = (payload) => ({
  type: UmsUserManagementActionTypes.SET_ANY_DATA,
  payload,
});

// fetch users
export const startFetchUsers = ({
  limit,
  offset,
  keyword,
  roleId,
  blocked,
}) => ({
  type: UmsUserManagementActionTypes.FETCH_UMS_USERS_START,
  payload: { limit, offset, keyword, roleId, blocked },
});

export const fetchUsersSuccess = (payload) => ({
  type: UmsUserManagementActionTypes.FETCH_UMS_USERS_SUCCESS,
  payload,
});

export const fetchUsersFailure = (payload) => ({
  type: UmsUserManagementActionTypes.FETCH_UMS_USERS_FAILURE,
  payload,
});

// fetch roles
export const startFetchRoles = () => ({
  type: UmsUserManagementActionTypes.FETCH_UMS_ROLES_START,
});

export const fetchRolesSuccess = (payload) => ({
  type: UmsUserManagementActionTypes.FETCH_UMS_ROLES_SUCCESS,
  payload,
});

export const fetchRolesFailure = (payload) => ({
  type: UmsUserManagementActionTypes.FETCH_UMS_ROLES_FAILURE,
  payload,
});

export const startFetchSingleRole = (id, cb) => ({
  type: UmsUserManagementActionTypes.FETCH_UMS_SINGLE_ROLE_START,
  payload: { id, cb },
});

export const fetchSingleRoleSuccess = (payload) => ({
  type: UmsUserManagementActionTypes.FETCH_UMS_SINGLE_ROLE_SUCCESS,
  payload,
});

export const fetchSingleRoleFailure = (payload) => ({
  type: UmsUserManagementActionTypes.FETCH_UMS_SINGLE_ROLE_FAILURE,
  payload,
});

export const saveRole = (data, cb) => ({
  type: UmsUserManagementActionTypes.SAVE_ROLE_START,
  payload: { data, cb },
});

export const editRole = (data, cb) => ({
  type: UmsUserManagementActionTypes.EDIT_ROLE_START,
  payload: { data, cb },
});

export const saveRoleSuccess = (payload) => ({
  type: UmsUserManagementActionTypes.SAVE_ROLE_SUCCESS,
  payload,
});

export const editRoleSuccess = (payload) => ({
  type: UmsUserManagementActionTypes.EDIT_ROLE_SUCCESS,
  payload,
});

export const saveRoleFailure = (payload) => ({
  type: UmsUserManagementActionTypes.SAVE_ROLE_FAILURE,
  payload,
});

export const deleteRole = (id, cb) => ({
  type: UmsUserManagementActionTypes.DELETE_ROLE_START,
  payload: { id, cb },
});

export const deleteRoleSuccess = (payload) => ({
  type: UmsUserManagementActionTypes.DELETE_ROLE_SUCCESS,
  payload,
});

export const deleteRoleFailure = (payload) => ({
  type: UmsUserManagementActionTypes.DELETE_ROLE_FAILURE,
  payload,
});

// fetch privileges
export const startFetchprivileges = () => ({
  type: UmsUserManagementActionTypes.FETCH_UMS_PRIVILEGES_START,
});

export const fetchprivilegesSuccess = (payload) => ({
  type: UmsUserManagementActionTypes.FETCH_UMS_PRIVILEGES_SUCCESS,
  payload,
});

export const fetchprivilegesFailure = (payload) => ({
  type: UmsUserManagementActionTypes.FETCH_UMS_PRIVILEGES_FAILURE,
  payload,
});

// fetch statistics
export const startFetchStatistics = () => ({
  type: UmsUserManagementActionTypes.FETCH_USER_STATISTICS_START,
});

export const fetchStatisticsSuccess = (payload) => ({
  type: UmsUserManagementActionTypes.FETCH_USER_STATISTICS_SUCCESS,
  payload,
});

export const fetchStatisticsFailure = (payload) => ({
  type: UmsUserManagementActionTypes.FETCH_USER_STATISTICS_FAILURE,
  payload,
});
